// extracted by mini-css-extract-plugin
export default {"header":"CustomDayPicker_header__x6kf-"};